// This is defined in app/containers/LanguageProvider/index.tsx
// Needs to be a function because exports in ES6 are static when exported, i.e. window.intlService is saved in a dedicated address and not a reference
const intlService = () => window.intlService;

export { intlService };
